import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/portada-taller.jpg")